import React, { useState } from "react";
import "./Withdrawal-pages.css";
// import successicon from "../../../../../Assets/success.svg";
import cardcloseicon from "../../../../../Assets/cardcloseicon.svg";
import { Util } from "../../../../../../helpers/util";
import { BANK_WITHDRAW } from "../../../../../../constants";
import { $api } from "../../../../../../helpers/$api";
// import { StyledBankTransferFormButton } from "../../../../../Syles/styles.js";

const CardPaymentSuccess = ({ setStage }) => {
  const { amount, bank_id } = Util.get(BANK_WITHDRAW, {});
  const [submitting, setSubmitting] = useState(false);

  const handleYesClick = async () => {
    if (submitting) {
      return;
    }
    try {
      setSubmitting(true);
      await $api.user.withdrawToBank({ amount, bank_id });
      window.location.reload();
    } catch (error) {
      alert(`error - ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cardpaymentsuccess">
      <div className="cardsuccesswrapper">
        <button
          className="closemodaliconsucess-btn"
          onClick={() => {
            setStage(0);
          }}
        >
          <img
            className="cardcloseicon "
            src={cardcloseicon}
            alt="card close icon"
          />
        </button>
        <div
          className=""
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        ></div>
        <div className="notice-head">
          <h5>Quick Notices</h5>

          <p>
            A withdrawal fee of N{amount} would be deducted from your account,
            do you want to continue?
          </p>
        </div>

        <div className="decide-session">
          <p
            onClick={() => {
              setStage(1);
            }}
            className="No"
          >
            NO, cancel
          </p>
          <p onClick={handleYesClick} className="yes">
            YES, continue
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardPaymentSuccess;
